import {
  Indicator,
  Root,
  type CheckboxProps as RootProps,
} from '@radix-ui/react-checkbox';
import cl from 'clsx';
import { type FC, forwardRef, type RefAttributes } from 'react';

import { CheckmarkBlueSVGIcon } from '@/shared/assets';

import classes from './Checkbox2.module.scss';

export type Checkbox2Props = Omit<
  RootProps,
  'onCheckedChange' | 'checked' | 'defaultChecked'
> &
  RefAttributes<HTMLButtonElement> & {
    onCheckedChange?: (checked: boolean) => void;
    checked?: boolean | null;
    defaultChecked?: boolean | null;
    color?: 'green' | 'primary' | 'red';
    size?: 'large' | 'small';
  };

export const Checkbox2: FC<Checkbox2Props & RefAttributes<HTMLButtonElement>> =
  forwardRef(function Checkbox2(
    {
      className,
      color = 'primary',
      size = 'small',
      disabled,
      checked,
      defaultChecked,
      ...props
    },
    ref,
  ) {
    return (
      <Root
        className={cl(classes.root, classes[color], classes[size], className)}
        ref={ref}
        checked={checked ?? undefined}
        defaultChecked={defaultChecked ?? undefined}
        {...props}
        disabled={disabled}
      >
        <Indicator asChild>
          <CheckmarkBlueSVGIcon className={classes.checkmark} />
        </Indicator>
      </Root>
    );
  });
